import React, { forwardRef } from "react";
import { ButtonSpinner } from "./button.spinner";
import { ButtonStyledComponent } from "./button.styles";
import { IButtonProps } from "./i-button";

const Button: React.FC<IButtonProps> = forwardRef<HTMLButtonElement, IButtonProps>(
   (
      { isLoading, variant, width, children, fullWidth, onClick, type = "button", size, ...rest },
      ref: any
   ) => {
      return (
         <ButtonStyledComponent
            size={size}
            fullWidth={fullWidth}
            type={type}
            variant={variant}
            onClick={onClick}
            ref={ref}
            disabled={isLoading}
            width={width}
            {...rest}
         >
            <span>{children}</span>
            <span style={{ marginLeft: "1em" }}>{isLoading && <ButtonSpinner />}</span>
         </ButtonStyledComponent>
      );
   }
);

Button.displayName = "Button";

export { Button };
